module.exports = __webpack_public_path__ + "static/img/wheel_toast_1.0846b0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/wheel_toast_1.png
// module id = 573
// module chunks = 1